import { Component, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ErrorHandlerService} from '../../services/error-handler.service';

@Component({
    selector: 'editable',
    templateUrl: 'editable.component.html',
    styles: [
        `
        .content {
            position: relative;
            min-height: 30px;
        }
        .edit-btn {
            border: none;
            top:2px;
            right:2px;
            opacity: 0.2;
            color: green;
        }
        .edit-btn:hover {
            background: #ffffff;
            opacity: 1;
        }
        `
    ]
})
export class EditableComponent implements OnInit {

    newContentValue;
    isEditing = false;
    modalRef: NgbModalRef;

    @Input() content;
    @Input() big = false;
    @Input() options;
    @Input() multiple;
    @Input() external: any;
    @Input() permission: string;
    @Input() isNumber: boolean;
    @Input() allowNegativeValue = true;

    @Output() submit: EventEmitter<any> = new EventEmitter();

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(evt: KeyboardEvent) {
        this.isEditing = false;
    }

    constructor(
      private modalService: NgbModal,
      private handler: ErrorHandlerService,
    ) {
    }

    ngOnInit() {
        this.newContentValue = this.content;
        if (this.external) {
          this.modalRef = this.modalService.open(this.external);
        }
    }

    openEdit() {
        this.isEditing = true;
        this.newContentValue = this.content;
    }

    save() {
      if (this.isNumber && !this.allowNegativeValue &&
        !isNaN(this.newContentValue) && Number(this.newContentValue) < 0) {
        this.handler.handle({
          error: 'Don\'n accept negative values'
        });

        return;
      }

      if (this.content !== this.newContentValue) {
        if (Array.isArray(this.newContentValue) && !this.multiple) {
          this.newContentValue = this.newContentValue[0];
        }

        this.submit.emit(this.isNumber && !isNaN(this.newContentValue) ?
          Number(this.newContentValue) : this.newContentValue);
        this.isEditing = false;
        if (this.modalRef) {
          this.modalRef.close();
        }
      }
    }

}
